module.exports = __webpack_public_path__ + "static/media/apartment5.74f444af.jpg";